import React from 'react'
import styles from './CardTable.module.scss'
import cx from 'classnames'
import { Icon } from 'components/shared/Icon/Icon'
import { ChevronDownIcon, ChevronUpIcon } from 'components/shared/Icon/model'
import * as R from 'ramda'

export const CardTableHeaderCell = ({
  children,
  width = 'auto',
  className,
  setOrder,
  order,
  id,
}) => (
  <th
    className={cx(styles.cardTableHeaderCell, {
      [styles.selectable]: Boolean(setOrder),
      [className]: Boolean(className),
    })}
    style={{ [`--width`]: width }}
    onClick={setOrder ? () => setOrder(id) : undefined}
  >
    {children}
    {R.isNil(order?.ascending) || order.column !== id ? null : (
      <span className={styles.icons}>
        <Icon
          icon={order.ascending ? ChevronUpIcon : ChevronDownIcon}
          size={20}
        />
      </span>
    )}
  </th>
)
